import { MultiSelect, MultiSelectItem } from "@amzn/storm-ui-multi-select";
import styled, { css } from "styled-components";

export const StyledFilterActionsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px 16px;
    border-top: 1px solid ${({ theme }) => theme.color.gray[200]};
`;

export const StyledLinkBox = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledMultiSelectWrapper = styled.div`
    display: contents;
    margin-right: 0;
`;

export const StyledCloseButton = styled.span<{
    disabled: boolean;
    isLoading: boolean;
}>`
    cursor: pointer;
    display: inline-flex;
    position: relative;
    top: 4px;
    right: 4px;
    font-weight: bold;
    font-size: 16px;
    line-height: 1;
    pointer-events: auto !important;
    margin-left: -18px;
    z-index: 1;
    &:hover {
        opacity: 0.7;
    }
`;

export const StyledMultiSelect = styled(MultiSelect)<{
    disabled: boolean;
    loading: boolean;
    hasCloseButton?: boolean;
}>`
    position: relative;
    padding-right: ${(props) => (props.hasCloseButton ? "25px" : "15px")};
`;

export const StyledMultiSelectItem = styled(MultiSelectItem)<{
    disabled: boolean;
}>`
    padding-top: 3px;
    padding-bottom: 3px;
    border-radius: 0px;
    ${(props) =>
        props.disabled &&
        css`
            pointer-events: none;
            background-color: ${({ theme }) =>
                theme.color.gray[100]} !important;
        `}
`;

export const TooltipWrapper = styled("div")`
    display: flex;
    span {
        flex-grow: 1;
    }
`;

export const StyledGroupCheckboxLabel = styled.span`
    font-weight: bold;
    font-size: 13px;
    color: #232f3e;
    margin-left: 5px;
`;
